import listTemplate from './views/list.tpl.html';
import editorTemplate from './views/editor.tpl.html';
import BillingPositionCategoriesEditController from './controllers/edit-controller';
import BillingPositionCategoriesCreateController from './controllers/create-controller';

angular
    .module('festzelt-os.billing.position_categories')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.billing.position_categories', {
            abstract: true,
            url: 'positions/categories',
            template: '<ui-view />',
            data: {
                pageTitle: 'Position categories'
            }
        })
        .state('app.billing.position_categories.index', {
            url: '',
            sticky: true,
            data: {
                right: 'billing::position_category-list',
                showBackBtn: false
            },
            templateUrl: listTemplate,
            controller: 'PositionCategoriesListCtrl',
            controllerAs: 'vm'
        })
        .state('app.billing.position_categories.create', {
            url: '/create',
            params: {
                positionCategory: undefined,
                store: undefined
            },
            data: {
                right: 'billing::position_category-create'
            },
            templateUrl: editorTemplate,
            controller: BillingPositionCategoriesCreateController,
            controllerAs: 'vm'
        })
        .state('app.billing.position_categories.edit', {
            url: '/{id}/edit',
            params: {
                positionCategory: undefined,
                store: undefined
            },
            data: {
                right: 'billing::position_category-edit'
            },
            templateUrl: editorTemplate,
            controller: BillingPositionCategoriesEditController,
            controllerAs: 'vm'
        });
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/position_categories/position_categories-routes.js